import React from 'react';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';

// "Book your demo now" block for the brochure sidebar.
//
// Wraps the existing <LeadGenerationButton> so the same LeadSquared activity
// and the same Today / Tomorrow / Attend-right-now slot options used on the
// main program page are preserved here verbatim. Only the button presentation
// and wrapper layout are specific to the brochure page.
//
// The `clickEvent` prop on LeadGenerationButton runs before the lead-gen
// modal opens, which is where we hook the brochure-specific analytics.
const BrochureHeroCta = ({ programName, buttonLocation, onCtaClick }) => {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-rubik text-xs uppercase tracking-wide text-v5-neutral-400">
        Viewing Official Brochure
      </p>
      <h1 className="font-manrope text-2xl font-extrabold leading-tight text-v5-neutral-600 md:text-3xl">
        {programName}
      </h1>
      <LeadGenerationButton
        type="Book Your Trial, Now"
        buttonLocation={buttonLocation}
        clickEvent={onCtaClick}
      />
    </div>
  );
};

export default BrochureHeroCta;
